import { randomId } from '../utils/randomId.js';

const isPlainObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value);

const ensureRowId = (row) => (isPlainObject(row) && !row.id ? { ...row, id: randomId() } : row);

const walk = (value) => {
  if (Array.isArray(value)) {
    let changed = false;
    const next = value.map((item) => {
      const walked = walk(item);
      changed = changed || walked !== item;
      return walked;
    });
    return changed ? next : value;
  }

  // Lexical states never contain filter rows; skipping them keeps the walk cheap.
  if (!isPlainObject(value) || value.type === 'lexical') {
    return value;
  }

  let changed = false;
  const next = {};
  for (const [key, propValue] of Object.entries(value)) {
    let walked;
    if (key === 'filterSet' && Array.isArray(propValue)) {
      let rowsChanged = false;
      const nextRows = propValue.map((row) => {
        const walkedRow = walk(ensureRowId(row));
        rowsChanged = rowsChanged || walkedRow !== row;
        return walkedRow;
      });
      walked = rowsChanged ? nextRows : propValue;
    } else {
      walked = walk(propValue);
    }
    changed = changed || walked !== propValue;
    next[key] = walked;
  }
  return changed ? next : value;
};

/**
 * Filter editors (FilterContainer and its sliders) target rows by their `id`,
 * so every row inside a `filterSet` array must carry one. This walks any config
 * value and assigns a `randomId()` to rows (and nested groups) that lack one.
 * Returns the input by identity when nothing was missing, so callers can use
 * reference equality to detect whether a repair happened.
 */
export const ensureFilterSetRowIds = (value) => walk(value);
